import { createContext, type ReactNode, useContext } from "react";

interface NavigationContextProps {
    navigation: {
        roomList: {
            room_idx: string;
            room_name: string;
        }[];
        specialList: {
            special_idx: string;
            special_name: string;
        }[];
    };
}

const NavigationContext = createContext<NavigationContextProps | undefined>(undefined);

interface NavigationProviderProps {
    children: ReactNode;
    value: NavigationContextProps;
}

export const NavigationProvider = ({ children, value }: NavigationProviderProps) => {
    return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
};

export const useNavigation = () => {
    const context = useContext(NavigationContext);

    if (context === undefined) {
        throw new Error("useNavigation must be used within a NavigationProvider");
    }
    return context;
};
